module.exports = __webpack_public_path__ + "img/1406216796.ccd5862f.jpg";